import { SurchargesOptimizationsActionTypes } from './constants';

type SurchargesOptimizationsAction = { type: string, payload: {} | string };

export const surchargesOptimizationsApiResponseSuccess = (actionType: string, data: any): SurchargesOptimizationsAction => ({
    type: SurchargesOptimizationsActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});

export const surchargesOptimizationsApiResponseError = (actionType: string, error: string): SurchargesOptimizationsAction => ({
    type: SurchargesOptimizationsActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const surchargesOptimizationsGetNoSurcharges = (query): SurchargesOptimizationsAction => ({
    type: SurchargesOptimizationsActionTypes.GET_SURCHARGES_NO_SURCHARGES,
    payload: { query },
});

export const surchargesOptimizationsGetNoNonShipmentSurcharges = (query): SurchargesOptimizationsAction => ({
    type: SurchargesOptimizationsActionTypes.GET_NO_NON_SHIPMENT_SURCHARGES,
    payload: { query },
});

export const surchargesOptimizationsGetNonShipmentSurchargesCost = (query): SurchargesOptimizationsAction => ({
    type: SurchargesOptimizationsActionTypes.GET_NON_SHIPMENT_SURCHARGES_COST,
    payload: { query },
});

export const surchargesOptimizationsGetSurchargesCost = (query): SurchargesOptimizationsAction => ({
    type: SurchargesOptimizationsActionTypes.GET_SURCHARGES_COST,
    payload: { query },
});

export const surchargesOptimizationsGetAuditableSurchargesCost = (query): SurchargesOptimizationsAction => ({
    type: SurchargesOptimizationsActionTypes.GET_AUDITABLE_SURCHARGES_COST,
    payload: { query },
});

export const surchargesOptimizationsGetSurchargesComparisonCost = (query): SurchargesOptimizationsAction => ({
    type: SurchargesOptimizationsActionTypes.GET_COMPARISON_SURCHARGES_COST,
    payload: { query },
});

export const surchargesOptimizationsGetRecords = (query): SurchargesOptimizationsAction => ({
    type: SurchargesOptimizationsActionTypes.GET_COMPARISON_ANALYTICS_RECORDS,
    payload: { query },
});